require('./bootstrap');

import FormControl from './components/form-control';
import Conditional from './components/conditional';
import Form from './components/form';
import Range from './components/range';
import Overlay from './components/overlay';
import Confirmation from './components/confirmation';

$(function () {

    $('.form-control').each((i, el) => {
        new FormControl($(el));
    });

    $('[data-conditional="el"]').each((i, el) => {
        new Conditional($(el));
    });

    $('[data-form="el"]').each((i, el) => {
        new Form($(el));
    });

    $('[data-range="el"]').each((i, el) => {
        if (!$(el).data('activity')) {
            new Range($(el));
        } else {
            let activityLabels = {
                '1': '',
                '1.1': '',
                '1.2': 'immobil, bettlägerig',
                '1.3': 'Teilmobil, gelegentliche Mobilisierung',
                '1.4': 'Mobil, häufige Mobilisierung; ausschliesslich sitzende Tätigkeiten mit wenig oder keiner anstrengenden Freizeitaktivität, (z.B. Büroangestellte, Feinmechaniker)',
                '1.5': '',
                '1.6': 'sitzende Tätigkeit, zeitweilig auch zusätzlicher Energieaufwand für gehende und stehende Tätigkeiten, (z.B. Laboranten, Studierende, Fliessbandarbeit)',
                '1.7': '',
                '1.8': 'überwiegend gehende und stehende Arbeit (z.B. Verkäufer, Kellner, Mechaniker, Handwerker)',
                '1.9': '',
                '2': 'Körperliche anstrengende Arbeit (z.B. Bauarbeiter, Landwirt, Waldarbeiter)',
            };
            new Range($(el), activityLabels);
        }
    });

    $('[data-confirmation="el"]').each((i, el) => {
        new Confirmation($(el));
    });

    // sortable patients table
    const patientsTable = document.querySelector('#patients-table');
    if (patientsTable) {
        Tablesort(patientsTable);
    }

    // sortable visits table
    const visitsTable = document.querySelector('#visits-table');
    if (visitsTable) {
        Tablesort(visitsTable);
    }

    // init tippy
    tippy('[data-tippy-content]', {
        trigger: 'click',
        allowHTML: true,
        maxWidth: 450,
    });

    new Overlay();


});
